module.exports = __webpack_public_path__ + "img/message-load.9c888088.gif";